<div class="thumb">
  <img [src]="backgroundImage" [style.image]="" />
  <img [src]="rasterImage || defaultImage" />
</div>
